import { useState, type FormEvent } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../api/axios'
import CampoSenha from '../components/CampoSenha'

export function RedefinirSenhaPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const [novaSenha, setNovaSenha] = useState('')
  const [confirmarSenha, setConfirmarSenha] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState(false)
  const navigate = useNavigate()

  async function salvar(e: FormEvent) {
    e.preventDefault()
    setErro('')
    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem')
      return
    }
    setSalvando(true)
    try {
      await api.post('/auth/redefinir-senha', { token, novaSenha })
      setSucesso(true)
    } catch (err: any) {
      setErro(err?.response?.data?.error ?? 'Falha ao redefinir a senha')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div className="min-h-[100dvh] bg-compumaq-preto flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-compumaq-pretoSuave border border-compumaq-dourado/25 rounded-2xl shadow-2xl p-8">
          <img
            src="/compumaq-logo.jpg"
            alt="Compumaq Tecnologia"
            className="w-16 h-16 rounded-2xl mb-4 mx-auto object-cover"
          />
          <h1 className="text-xl font-bold text-compumaq-texto text-center mb-6">Nova senha</h1>

          {!token && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-red-600 text-center">Link inválido - falta o token de redefinição.</p>
            </div>
          )}

          {sucesso ? (
            <>
              <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-3 text-sm text-green-400 text-center">
                Senha redefinida com sucesso.
              </div>
              <button
                onClick={() => navigate('/login')}
                className="w-full mt-4 bg-compumaq-dourado text-compumaq-texto py-2.5 rounded-lg font-semibold text-sm hover:bg-compumaq-doradoClaro transition-colors"
              >
                Ir para o login
              </button>
            </>
          ) : (
            token && (
              <form onSubmit={salvar} className="space-y-5">
                {erro && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                    <p className="text-sm text-red-600">{erro}</p>
                  </div>
                )}
                <div>
                  <label htmlFor="novaSenha" className="block text-sm font-medium text-compumaq-textoSuave mb-1">
                    Nova senha
                  </label>
                  <CampoSenha
                    id="novaSenha"
                    required
                    minLength={6}
                    autoFocus
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-lg border border-compumaq-dourado/25 bg-compumaq-preto text-compumaq-texto text-sm focus:outline-none focus:ring-2 focus:ring-compumaq-dourado"
                  />
                </div>
                <div>
                  <label htmlFor="confirmarSenha" className="block text-sm font-medium text-compumaq-textoSuave mb-1">
                    Confirmar nova senha
                  </label>
                  <CampoSenha
                    id="confirmarSenha"
                    required
                    minLength={6}
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-lg border border-compumaq-dourado/25 bg-compumaq-preto text-compumaq-texto text-sm focus:outline-none focus:ring-2 focus:ring-compumaq-dourado"
                  />
                </div>
                <button
                  type="submit"
                  disabled={salvando}
                  className="w-full bg-compumaq-dourado text-compumaq-texto py-2.5 rounded-lg font-semibold text-sm hover:bg-compumaq-doradoClaro transition-colors disabled:opacity-60"
                >
                  {salvando ? 'Salvando...' : 'Redefinir senha'}
                </button>
              </form>
            )
          )}

          <Link to="/login" className="block text-center text-xs text-compumaq-doradoClaro hover:underline mt-4">
            ← Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  )
}
